import { MediaTypeElement } from '@swagger-api/apidom-ns-openapi-3-1';
/**
 * @public
 */
class MediaType extends MediaTypeElement {
  get schema() {
    return this.get('schema');
  }
  set schema(schema) {
    this.set('schema', schema);
  }

  /**
   * OpenAPI 3.2: Schema for items in sequential/streaming media types.
   * Used for formats like application/jsonl, application/json-seq, text/event-stream.
   */
  get itemSchema() {
    return this.get('itemSchema');
  }
  set itemSchema(itemSchema) {
    this.set('itemSchema', itemSchema);
  }

  /**
   * OpenAPI 3.2: An array of positional encoding information for sequential/streaming formats.
   * The prefixEncoding field SHALL only apply when the media type is multipart.
   */
  get prefixEncoding() {
    return this.get('prefixEncoding');
  }
  set prefixEncoding(prefixEncoding) {
    this.set('prefixEncoding', prefixEncoding);
  }

  /**
   * OpenAPI 3.2: A single Encoding Object that provides encoding information for array items.
   * The itemEncoding field SHALL only apply when the media type is multipart.
   */
  get itemEncoding() {
    return this.get('itemEncoding');
  }
  set itemEncoding(itemEncoding) {
    this.set('itemEncoding', itemEncoding);
  }
}
export default MediaType;